module.exports = __webpack_public_path__ + "static/media/Cat2.8e90d3f3.png";